/* N1 · Comparador: orden por calidad, filtro POR TALLA, robot e Iris.
   07/10/2026 (multidioma fase 2, lote 3b): textos desde window.N1T (n1.cmp.*); el chip lleva el ID en data-h y el handle en data-hd. */
(function(){
if(window.N1CmpBot)return;window.N1CmpBot=1;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};
var BOT='<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="7" width="16" height="12" rx="3"/><path d="M12 3v4"/><circle cx="12" cy="2.5" r="1.2"/><path d="M9 12h.01M15 12h.01"/><path d="M9.5 16h5"/><path d="M1.8 11v3M22.2 11v3"/></svg>';
var OUT=/wc26|gloves-of-nations|shadow|edicion|edición|limited/i;
var ORDER=[/hera/i,/zeus(?!.*kids)/i,/sirius.*ugt/i,/scorpius.*ugt/i,/horus(?!.*kids)/i,/ares.*ugt/i,/gea/i,/cronos.*duo/i,/cronos.*ugt/i,/beta(?!.*kids)/i,/scorpius.*ssg/i,/sirius.*ssg/i,/cronos.*ssg/i,/kids|niñ|fluor|purple/i,/starter/i];
function rank(t){for(var i=0;i<ORDER.length;i++)if(ORDER[i].test(t))return i;return 98}
function nums(t){return (t||'').split(/[^0-9]+/).filter(Boolean).map(Number)}
function data(){
  var s=[].slice.call(document.querySelectorAll('script[type="application/json"]')).filter(function(x){return /^cmpd/.test(x.id)})[0];
  if(!s)return null;try{return JSON.parse(s.textContent)}catch(e){return null}
}
function organise(){
  var bar=document.querySelector('.n1-compare .bar');
  if(!bar||bar.dataset.sorted)return;
  var chips=[].slice.call(bar.querySelectorAll('.chip'));
  if(!chips.length)return;
  var D=data();
  var tallas={};
  if(D)D.items.forEach(function(x){tallas[x.h]=nums(x.specs.tallas)});
  chips.forEach(function(c){
    var id=c.getAttribute('data-h')||'',h=c.getAttribute('data-hd')||id,t=(c.textContent||'').trim();
    if(OUT.test(h)||OUT.test(t+' '+h)){c.remove();return}
    c.dataset.r=rank(t+' '+h);
    c.dataset.tallas=(tallas[id]||[]).join(',');
  });
  var live=[].slice.call(bar.querySelectorAll('.chip'));
  live.sort(function(a,b){return (+a.dataset.r)-(+b.dataset.r) || a.textContent.localeCompare(b.textContent)});
  live.forEach(function(c){bar.appendChild(c)});
  bar.dataset.sorted=1;
  addFilter(bar,live);
}
function addFilter(bar,chips){
  if(bar.previousElementSibling&&bar.previousElementSibling.classList.contains('n1cf'))return;
  var all={};
  chips.forEach(function(c){(c.dataset.tallas||'').split(',').filter(Boolean).forEach(function(n){all[n]=1})});
  var sizes=Object.keys(all).map(Number).sort(function(a,b){return a-b});
  if(!sizes.length)return;
  var f=document.createElement('div');
  f.className='n1cf';
  f.innerHTML='<span class="n1cf__l">'+T('n1.cmp.your_size','Tu talla')+'</span><div class="n1cf__g"><button type="button" class="n1cf__b on" data-t="">'+T('n1.cmp.all_sizes','Todas')+'</button>'+
    sizes.map(function(n){return '<button type="button" class="n1cf__b" data-t="'+n+'">'+n+'</button>'}).join('')+'</div>';
  bar.parentNode.insertBefore(f,bar);
  f.addEventListener('click',function(e){
    var b=e.target.closest('.n1cf__b');if(!b)return;
    f.querySelectorAll('.n1cf__b').forEach(function(x){x.classList.remove('on')});
    b.classList.add('on');
    var t=b.getAttribute('data-t');
    bar.querySelectorAll('.chip').forEach(function(c){
      var list=(c.dataset.tallas||'').split(',');
      c.style.display=(!t||list.indexOf(t)>-1)?'':'none';
    });
  });
}
function run(){
  organise();
  document.querySelectorAll('.n1-compare .ask__av, .n1-compare .card__av').forEach(function(el){
    if(el.dataset.bot)return;el.dataset.bot=1;el.innerHTML=BOT;
  });
  document.querySelectorAll('.n1-compare .card__b > b').forEach(function(el){
    if(el.dataset.iris)return;el.dataset.iris=1;el.textContent=T('n1.cmp.iris','Iris · Asistente N1');
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,600);setTimeout(run,1500);
new MutationObserver(function(){clearTimeout(window.__n1cb);window.__n1cb=setTimeout(run,300)}).observe(document.documentElement,{childList:true,subtree:true});
})();
